function productSlider() {
 let slider = document.querySelectorAll('.slider');

 if (slider.length > 0) {
  for (let i = 0; i < slider.length; i++) {
   if (slider[i].classList.contains('slider-products')) {
    let sliderContainer = slider[i].querySelector('.slider-container');

    let sliderList = sliderContainer.querySelector('.slider-list');
    let sliderItems = sliderContainer.querySelectorAll('.slider-list LI');
    let itemWidth = sliderList.querySelector('LI').getBoundingClientRect().width + 24;
    let prev = sliderContainer.querySelector('.prev');
    let next = sliderContainer.querySelector('.next');
    let currentSlide = 0;
    let mediaLaptop = window.matchMedia('(min-width: 831px) and (max-width: 1100px)');
    let mediaTablet = window.matchMedia('(min-width: 501px) and (max-width: 830px)');
    let mediaPhone = window.matchMedia('(max-width: 500px)');

    function moveSlide() {
     sliderList.style.transform = `translateX(-${currentSlide * itemWidth}px)`;
    }

    function countSlide() {
     if (mediaLaptop.matches) {
      return 3;
     } else if (mediaTablet.matches) {
      return 2;
     } else if (mediaPhone.matches) {
      return 1;
     } else {
      return 4;
     }
    }

    next.addEventListener('click', (e) => {
     e.preventDefault();

     currentSlide++;

     if (currentSlide > sliderItems.length - countSlide()) {
      currentSlide = 0;
     }

     moveSlide()
    })

    prev.addEventListener('click', (e) => {
     e.preventDefault();

     currentSlide--;

     if (currentSlide <= 0) {
      currentSlide = sliderItems.length - countSlide();
     }

     moveSlide()
    })
   }

   if (slider[i].classList.contains('slider-images')) {
    let sliderContainer = slider[i].querySelector('.slider-container');

    let sliderList = sliderContainer.querySelector('.slider-list');
    let sliderItems = sliderContainer.querySelectorAll('.slider-list LI');
    let itemWidth = sliderList.querySelector('LI').getBoundingClientRect().width + 24;
    let prev = sliderContainer.querySelector('.prev');
    let next = sliderContainer.querySelector('.next');
    let dots = sliderContainer.querySelector('.dots span');
    let currentSlide = 0;
    let mediaTablet = window.matchMedia('(min-width: 501px) and (max-width: 830px)');
    let mediaPhone = window.matchMedia('(max-width: 500px)');

    function moveSlide() {
     sliderList.style.transform = `translateX(-${currentSlide * itemWidth}px)`;
     setTimeout(() => {
      sliderContainer.querySelectorAll('.dots span').forEach(el => {
       el.classList.remove('active');
      })
      sliderContainer.querySelectorAll('.dots span')[currentSlide].classList.add('active');
     }, 100);
    }

    function countSlide() {
     if (mediaTablet.matches) {
      return 2;
     } else if (mediaPhone.matches) {
      return 1;
     } else {
      return 3;
     }
    }

    function countDots() {
     if (mediaTablet.matches) {
      return 1;
     } else if (mediaPhone.matches) {
      return 0;
     } else {
      return 2;
     }
    }

    function sliderDots() {
     let dotsContainer = document.createElement('div');
     dotsContainer.classList.add('dots');
     for (let i = 0; i < sliderItems.length - countDots(); i++) {
      let dot = document.createElement('span');
      dot.setAttribute('data-slide-id', `${i}`)
      dot.addEventListener('click', function (e) {
       e.preventDefault();
       sliderList.style.transform = `translateX(-${dot.getAttribute('data-slide-id') * itemWidth}px)`;
       sliderContainer.querySelectorAll('.dots span').forEach(el => {
        el.classList.remove('active');
       })
       sliderContainer.querySelectorAll('.dots span')[dot.getAttribute('data-slide-id')].classList.add('active');
       currentSlide = dot.getAttribute('data-slide-id');
      })
      dotsContainer.appendChild(dot);
      sliderContainer.appendChild(dotsContainer);
      sliderContainer.querySelectorAll('.dots span')[0].classList.add('active');
     }
    }
    sliderDots()

    next.addEventListener('click', (e) => {
     e.preventDefault();

     currentSlide++;

     if (currentSlide > sliderItems.length - countSlide()) {
      currentSlide = 0;
     }

     moveSlide()
    })

    prev.addEventListener('click', (e) => {
     e.preventDefault();

     currentSlide--;

     if (currentSlide < 0) {
      currentSlide = sliderItems.length - countSlide();
     }

     moveSlide()
    })
   }
  }
 }
}
productSlider()